import axios from 'axios';
import httpClient from '../httpClient';
import store from 'redux/configureStore';

export const getAllSources = (csv, count) => {
    return httpClient
        .get('/api/v2/source?help=false&csv=false&count=false&page=1&itemsOnPage=9999&sort=%5B%5D&filter=%5B%5D')
        // .get('/api/v2/source?itemsOnPage=9999&sort=%5B%5B%22source.name%22%2C%20%22asc%22%5D%5D')
        //?itemsOnPage=9999&sort=%5B%5B%22source.name%22%2C%20%22asc%22%5D%5D
        .then((res) => res.data)
        .catch((e) => {
            throw e.response.data.content;
        });
};